module.exports = __webpack_public_path__ + "img/icon-sb-brand-icon-v1.af63972.svg";